import { stringify } from '@angular/compiler/src/util';
import { group } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { LoginService } from 'src/app/shared/API-Service/services/login.service';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styles: [
  ]
})
export class ChangePasswordComponent implements OnInit {

  changepasswordForm:FormGroup;
  button:boolean = false;
  constructor(private _FormBuilder: FormBuilder, private _router:Router,private _LoginService:LoginService) {}
  ngOnInit(): void {
    this.initiate();
   }

  initiate(){
    this.changepasswordForm = this._FormBuilder.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', Validators.required]
    });
  }
  get fc() {
    return this.changepasswordForm.controls;
  }

    
  onSubmit() {
    this._LoginService.changepassword(this.changepasswordForm.value).subscribe((res) => {
      console.log(res.data);
      this.changepasswordForm.reset();
    },(err) => {
      console.log('their is a problem ');
    },() => {
      console.log('completed');
    })
  }


}
